function hasExclusiveTax(line = {}) {
  return (line.taxes ?? []).some(
    (tax) => String(tax?.tax_type ?? tax?.taxType ?? '').toUpperCase() === 'EXCLUSIVE',
  );
}

export function getLineDisplayTotal(line = {}) {
  if (hasExclusiveTax(line) && line.lineSubtotal !== undefined && line.lineSubtotal !== null) {
    return line.lineSubtotal;
  }

  return line.lineTotal ?? line.lineSubtotal ?? line.basePrice ?? 0;
}
